let allIds = [];
let currentTabId = null;
let visibleLimit = 8;
let visibleCount = 8;

function getAllIds() {
    const activeTabId = $("#productFinderTabContent .tab-pane.active.show").attr("id");

    if (currentTabId === activeTabId && allIds.length > 0) {
        return allIds;
    }

    currentTabId = activeTabId;
    allIds = [];

    $("#productFinderTabContent .tab-pane.active.show .listItem").each(function () {
        allIds.push(this.id);
    });

    return allIds;
}

function getIdsByFilterValue(value) {
    let ids = [];
    let selector = $();

    if (value && value.trim() !== "") {
        const safeValue = $.escapeSelector(value.trim());
        selector = $("#productFinderTabContent .tab-pane.active.show .listItem." + safeValue);
    }

    if (selector.length === 0) {
        ids = getAllIds();
    } else {
        selector.each(function () {
            let id = $(this).attr("id");
            ids.push(id);
        });
    }
    return ids;
}

function hasActiveFilters() {
    const currentTab = $('.tab-pane.active.show');
    let active = false;

    currentTab.find('select:not(.simple)').each(function () {
        if ($(this).val() &&$(this).val().trim() !== "") {
            active = true;
        }
    });

    if (!active) {
        if (currentTab.find('.productBenefitContainer input[type="checkbox"]:checked').length > 0) {
            active = true;
        }
    }

    return active;
}

function showItems() {
    const activeTab = $('.tab-pane.active.show');
    let ids = getAllIds();

    const filtersActive = hasActiveFilters();

    if (!filtersActive) {
        activeTab.find('.listItem').hide();
        updateLoadMoreButton(0);
        return [];
    }

    activeTab.find('select:not(.simple)').each(function () {
        let val = $(this).val();
        if (val && val.trim() !== "") {
            let tmp_ids = getIdsByFilterValue(val);
            ids = $.arrayIntersect(tmp_ids, ids);
        }
    });

    activeTab.find('.productBenefitContainer input[type="checkbox"]:checked').each(function () {
        let val = $(this).val();
        if (val && val.trim() !== "") {
            let tmp_ids = getIdsByFilterValue(val);
            ids = $.arrayIntersect(tmp_ids, ids);
        }
    });

    activeTab.find('.listItem').hide();

    let itemsToShowCount = Math.min(ids.length, visibleCount);

    for (let i = 0; i < itemsToShowCount; i++) {
        activeTab.find('.listItem#' + ids[i]).show();
    }

    updateLoadMoreButton(ids.length);

    return ids;
}

function updateLoadMoreButton(totalFilteredCount) {
    const activeTab = $('.tab-pane.active.show');
    let $wrapper = activeTab.find('.load-more-wrapper');
    let $btn;

    if ($wrapper.length === 0) {
        $wrapper =$(`
            <div class="row load-more-wrapper mb-5" style="display: none;">
                <div class="col text-center">
                    <a class="outline-action-link cursor--pointer float-none load-more-btn"></a>
                </div>
            </div>
        `);

        activeTab.append($wrapper);
        $btn =$wrapper.find('.load-more-btn');

        $btn.on('click', function () {
            let currentTotal = $(this).data('total') || 0;

            if (visibleCount >= currentTotal) {
                visibleCount = visibleLimit;
            } else {
                visibleCount += visibleLimit;
            }
            showItems();
        });
    } else {
        $btn =$wrapper.find('.load-more-btn');
    }

    $btn.data('total', totalFilteredCount);

    if (totalFilteredCount > visibleLimit) {
        $wrapper.show();

        if (visibleCount >= totalFilteredCount) {
            $btn.text($("#showLessText").text());
        } else {
            $btn.text($("#showMoreText").text());
        }
    } else {
        $wrapper.hide();
    }
}

function updateSelect(filteredIds) {
    let filtersActive = hasActiveFilters();

    if (!filtersActive || !filteredIds) {
        $('.tab-pane.active.show select:not(.simple) option').prop('disabled', false);
        return;
    }

    let currentTab = $('.tab-pane.active.show');

    let filteredElements = $();
    filteredIds.forEach(id => {
        filteredElements = filteredElements.add(currentTab.find('.listItem#' + id));
    });

    currentTab.find('select:not(.simple)').each(function () {
        $(this).find("option").each(function () {
            const val = $(this).val();
            if (!val) return;

            const match = filteredElements.filter((i, element) => {
                return $(element).hasClass(val);
            });
            const isOptionActive = match.length > 0;
            $(this).prop('disabled', !isOptionActive);
        });
    });
}

function updateCheckbox(filteredIds) {
    let filtersActive = hasActiveFilters();

    if (!filtersActive || !filteredIds) {
        $('.tab-pane.active.show .productBenefitContainer input').prop('disabled', false);
        return;
    }

    let currentTab = $('.tab-pane.active.show');

    let filteredElements = $();
    filteredIds.forEach(id => {
        filteredElements = filteredElements.add(currentTab.find('.listItem#' + id));
    });

    currentTab.find('.productBenefitContainer input').each(function () {
        const val = $(this).val();
        if (!val) return;

        const match = filteredElements.filter((i, element) => {
            return $(element).hasClass(val);
        });
        const isCheckboxActive = match.length > 0;
        $(this).prop('disabled', !isCheckboxActive);
    });
}

function generateFiltersQueryParameter() {
    let filters = [];
    let searchString = "";
    let filtersString;
    let currentTab = $('.tab-pane.active.show');

    currentTab.find('select:not(.simple)').each(function () {
        if ($(this) &&$(this).val() !== "") {
            filters.push($(this).val());
        }
    });

    currentTab.find('.productBenefitContainer input[type="checkbox"]:checked').each(function () {
        filters.push($(this).val());
    });

    if (filters && filters.length > 0) {
        filtersString = "";
        filters.forEach(function (filter) {
            filtersString += filter + ",";
        });
        filtersString = (searchString ? "" : "?") + "filters=" + filtersString.slice(0, -1) + "&selectedTab=" + currentTab[0].id;
        currentTab.find('.filters_reset_link').css("display", "inline-block");
    } else {
        currentTab.find('.filters_reset_link').css("display", "none");
    }

    window.history.replaceState(null, null, (searchString || "") + (filtersString || "?"));
}

function getQueryParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function applyFiltersFromQueryParameter() {
    let looped = false;
    let filtersQueryParameter = getQueryParameterByName("filters", window.location.href);
    let currentTab = $('.tab-pane.active.show');

    if (filtersQueryParameter) {
        let filtersList = filtersQueryParameter.split(",");
        if (filtersList && filtersList.length > 0) {

            filtersList.forEach(function (filter) {
                currentTab.find('select:not(.simple)').each(function () {
                    let $option =$(this).find('option').filter(function () {
                        return $(this).val() === filter;
                    });
                    if ($option.length) {
                        let currentVal = $(this).val() || [];
                        if (!currentVal.includes(filter)) {
                            currentVal.push(filter);
                            $(this).val(currentVal).trigger('change.select2');
                        }
                        showSelectedValue($(this));
                    }
                });

                currentTab.find('.productBenefitContainer input').each(function () {
                    if ($(this).val() === filter) {
                        $(this).prop('checked', true);$('button[data-target="#' + currentTab[0].id + '_productBenefit"]').click();
                        showSelectedValue($(this));
                    }
                });

                looped = true;
            });
            let filteredIds = showItems();
            updateSelect(filteredIds);
            updateCheckbox(filteredIds);
        }
        currentTab.find('.filters_reset_link').css("display", "inline-block");
    }

    if (!looped) {
        let filteredIds = showItems();
        updateSelect(filteredIds);
        updateCheckbox(filteredIds);
    }
}

function showSelectedValue(input) {
    let filterName = (input[0].id);
    let selectedText = "";

    if (input[0].type === "checkbox") {
        selectedText = $('label[for="' + filterName + '"]').text();
    } else {
        selectedText = input.find("option:selected").text();
    }
    $("#af-" + filterName + " span").text(selectedText);
    $("#af-" + filterName).removeClass("d-none");
}

function removeActiveFilter(filterName) {
    let filterSelector = $("#" + filterName);
    if (filterSelector.prop("type") === "checkbox") {
        filterSelector.prop('checked', false);
    } else {
        filterSelector.val("").trigger("change");
    }
    $("#af-" + filterName).addClass("d-none");
    let filteredIds = showItems();
    updateSelect(filteredIds);
    updateCheckbox(filteredIds);
    generateFiltersQueryParameter();
}

$(document).ready(function () {
    initializeProductFinder();
});

$('button[data-toggle="tab"]').on('shown.bs.tab', function () {
    visibleCount = visibleLimit;
    initializeProductFinder();
});

$('button[data-toggle="tab"]').on('hide.bs.tab', function () {
    let filtersQueryParameter = getQueryParameterByName("filters", window.location.href);
    let tabParameter = getQueryParameterByName("selectedTab", window.location.href);
    if (filtersQueryParameter && tabParameter === $('.tab-pane.active.show')[0].id) {
        let filtersSaved = "?filters=" + filtersQueryParameter + "&selectedTab=" + tabParameter;
        $('.tab-pane.active.show').find(".urlSaved").text(filtersSaved);
        resetLink();
    }
});

function initializeProductFinder() {
    let currentTab = $('.tab-pane.active.show');
    let selectSelector = currentTab.find('select:not(.simple)');
    let checkboxSelector = currentTab.find('input');

    let query = currentTab.find(".urlSaved").text();
    if (query) {
        history.replaceState(null, "", query);
    }

    let tabParameter = getQueryParameterByName("selectedTab", window.location.href);
    if (tabParameter) {
        if (currentTab[0].id !== tabParameter) {
            $('button[data-target="#' + tabParameter + '"]').click();
        } else {
            removeNotFindFilters();
        }
    } else {
        removeNotFindFilters();
    }

    selectSelector.off("select2:select").on("select2:select", function () {
        visibleCount = visibleLimit;
        let filteredIds = showItems();
        updateSelect(filteredIds);
        updateCheckbox(filteredIds);
        showSelectedValue($(this));
        generateFiltersQueryParameter();
    });

    checkboxSelector.off("click").on("click", function () {
        visibleCount = visibleLimit;
        let filteredIds = showItems();
        updateCheckbox(filteredIds);
        updateSelect(filteredIds);
        generateFiltersQueryParameter();
        if ($(this).is(":checked")) {
            showSelectedValue($(this));
        } else {
            removeActiveFilter($(this)[0].id);
        }
    });

    currentTab.find('.filters_reset_link').off('click').on('click', function () {
        resetLink();
    });

    applyFiltersFromQueryParameter();
}

function resetLink() {
    visibleCount = visibleLimit;
    let currentTab = $('.tab-pane.active.show');
    let selectSelector = currentTab.find('select:not(.simple)');
    let checkboxSelector = currentTab.find('input');

    selectSelector.each(function () {
        $(this).val("").trigger("change");
    });
    checkboxSelector.each(function () {
        $(this).prop('checked', false);
    });
    let filteredIds = showItems();
    updateCheckbox(filteredIds);
    updateSelect(filteredIds);
    $('[id^="af-"]').addClass("d-none");
    generateFiltersQueryParameter();
}

function removeNotFindFilters() {
    let currentTab = $('.tab-pane.active.show');
    let selectSelector = currentTab.find('select:not(.simple)');
    let checkboxSelector = currentTab.find('input');

    selectSelector.each(function () {
        $(this).find('option').each(function () {
            if ($(this).val() !== "") {
                if ($("#productFinderTabContent .tab-pane.active.show .listItem." + CSS.escape($(this).val())).length === 0) {$(this).remove();
                }
            }
        });

        if ($(this).find('option').length === 1) {$(this).closest(".select-column").remove();
        }
    });

    checkboxSelector.each(function () {
        if ($(this).val() !== "") {
            if ($("#productFinderTabContent .tab-pane.active.show .listItem." + CSS.escape($(this).val())).length === 0) {$(this).closest(".checkbox-column").remove();
            }
        }
    });
}